import api from "./client";
import {
  AddGuestPayload,
  BulkAddGuestsPayload,
  BulkAddGuestsResponse,
  ConfirmRsvpPayload,
  ConfirmRsvpResponse,
  Guest,
  GuestWithRsvp,
  ManageRsvpResponse,
  MatchRsvpPayload,
  MatchRsvpResponse,
  PlusOneEntry,
  Rsvp,
} from "../types";

export const matchRsvp = (data: MatchRsvpPayload) => {
  return api.post<MatchRsvpResponse>("/rsvp/match", data);
};

export const confirmRsvp = (data: ConfirmRsvpPayload) => {
  return api.post<ConfirmRsvpResponse>("/rsvp/confirm", data);
};

export const addGuest = (data: AddGuestPayload) => {
  return api.post<{ guest: Guest; rsvp: Rsvp; email_warning?: string | null }>(
    "/rsvp/guests",
    data
  );
};

export const bulkAddGuests = (data: BulkAddGuestsPayload) => {
  return api.post<BulkAddGuestsResponse>("/rsvp/guests/bulk", data);
};

export const getGuests = (weddingId: string) => {
  return api.get<GuestWithRsvp[]>("/rsvp/guests", { params: { weddingId } });
};

export const removeGuest = (guestId: string) => {
  return api.delete<{ success: boolean }>(`/rsvp/guests/${guestId}`);
};

export const updateGuest = (
  guestId: string,
  data: Partial<{
    full_name: string;
    email: string | null;
    phone: string | null;
    ticket_tier: string;
    plus_one_limit: number;
  }>
) => {
  return api.patch<Guest>(`/rsvp/guests/${guestId}`, data);
};

export const resendGuestInvite = (guestId: string) => {
  return api.post<{ success: boolean; email_warning?: string | null }>(
    `/rsvp/guests/${guestId}/invite`
  );
};

export const getManageRsvp = (rsvpId: string, seat?: string | null) => {
  return api.get<ManageRsvpResponse>(`/rsvp/manage/${rsvpId}`, {
    params: seat ? { seat } : undefined,
  });
};

export const addPlusOnes = (rsvpId: string, plusOnes: PlusOneEntry[]) => {
  return api.post<{
    plus_ones: Guest[];
    remaining?: number;
    email_warning?: string | null;
  }>("/rsvp/plus-ones", {
    rsvp_id: rsvpId,
    plus_ones: plusOnes,
  });
};
